// extracted by mini-css-extract-plugin
module.exports = {"showText":"style_showText__1bory","rateButton":"style_rateButton__3t2K6"};